import { computed, reactive, ref } from 'vue'
import * as api from '@/modules/authentication-logs/api'
import { SimpleListFilterParameters } from '@/views/_shared/search-list/types'
import { AuthenticationLog } from '@/modules/authentication-logs/types'

export * from './types'

const authenticationLogs = ref<AuthenticationLog[]>([])
const authenticationLogsCount = ref<number>()

const defaultSortBy = 'id desc'

export const authenticationLogsFilter = reactive<SimpleListFilterParameters>({
    search: '',
    sortBy: null,
    limit: 10,
    offset: 0
})

const getAuthenticationLogs = () => {
    return api.getAuthenticationLogsList(
        authenticationLogsFilter.search,
        authenticationLogsFilter.sortBy || defaultSortBy,
        authenticationLogsFilter.limit,
        authenticationLogsFilter.offset
    ).then(
        authenticationLogsList => {
            authenticationLogs.value = authenticationLogsList.results
            authenticationLogsCount.value = authenticationLogsList.count
        }
    )
}

export function useAuthenticationLogsModule () {
    return {
        authenticationLogs: computed(() => authenticationLogs.value),
        authenticationLogsCount: computed(() => authenticationLogsCount.value),
        getAuthenticationLogs,
        getAuthenticationLog: api.getAuthenticationLog,
        authenticationLogsFilter
    }
}
